import { IsNotEmpty, IsString, MaxLength, IsOptional, IsUUID } from 'class-validator';
import { TeamAccessEditDTO } from '../team/team-access-edit.dto';

export class ProductVersionEditDTO extends TeamAccessEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(50)
    version: string;

    @IsOptional()
    @IsString()
    description: string;

    @IsNotEmpty()
    @IsUUID()
    product: string;

}
